export default __webpack_public_path__ + "static/media/Agentes_on_light_blue.1daf97ff.svg";